import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Invoice } from './Invoice';
import { UserInvoice } from './UserInvoice';

export const InvoiceGenerator = ({ data, isUserInvoice = false }) => {
  const invoiceRef = useRef(null);

  const generatePDF = async () => {
    const element = invoiceRef.current;
    
    // Set a fixed width for better PDF quality
    const pdfWidth = 800;
    const pdfHeight = 1132; // A4 ratio

    const canvas = await html2canvas(element, {
      scale: 2,
      logging: false,
      useCORS: true,
      width: pdfWidth,
      height: element.scrollHeight,
      windowWidth: pdfWidth,
    });

    const imgData = canvas.toDataURL('image/png');
    
    // Use A4 format
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: 'a4'
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Add image to PDF
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

    // Add more pages if content overflows
    if (imgHeight > pageHeight) {
      const numberOfPages = Math.ceil(imgHeight / pageHeight);
      for (let i = 1; i < numberOfPages; i++) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          'PNG',
          0,
          -(pageHeight * i),
          imgWidth,
          imgHeight
        );
      }
    }

    pdf.save(`Invoice_${data.invoiceNo}.pdf`);
  };

  return (
    <div>
      <div className="mb-4 flex justify-end">
        <button
          onClick={generatePDF}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Download PDF
        </button>
      </div>
      
      <div className="max-w-4xl mx-auto overflow-auto">
        {isUserInvoice ? (
          <UserInvoice ref={invoiceRef} {...data} />
        ) : (
          <Invoice ref={invoiceRef} {...data} />
        )}
      </div>
    </div>
  );
};